export const getMarketplaceLabel = (url) => {
  if (!url) return null;
  try {
    const host = new URL(url).hostname.replace('www.', '');
    if (host.includes('amazon')) return 'Amazon';
    if (host.includes('flipkart')) return 'Flipkart';
    if (host.includes('myntra')) return 'Myntra';
    return host.split('.')[0].replace(/^\w/, c => c.toUpperCase());
  } catch {
    return 'Store';
  }
};
